/**
 * WebsiteAbout — "why us" tile + about text + stats.
 */
export default function WebsiteAbout({ config }) {
  const about = config.about || {};
  const why = Array.isArray(config.why_us) ? config.why_us : [];
  const primary = config.brand?.primary || '#0f4c81';

  return (
    <section id="about" className="py-20 lg:py-24 bg-slate-50" data-testid="ws-about">
      <div className="max-w-6xl mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-12 lg:gap-16 items-start">
        <div>
          <p className="text-[11px] font-bold uppercase tracking-[0.2em] text-slate-500 mb-2.5">
            About {config.business_name}
          </p>
          {about.headline && (
            <h2 className="text-3xl lg:text-4xl font-black tracking-tight text-slate-900 leading-tight">
              {about.headline}
            </h2>
          )}
          {about.body && (
            <p className="mt-6 text-base text-slate-600 leading-relaxed" data-testid="ws-about-body">
              {about.body}
            </p>
          )}
          {Array.isArray(about.stats) && about.stats.length > 0 && (
            <div className="mt-8 grid grid-cols-3 gap-4">
              {about.stats.map((s) => (
                <div key={s.label} className="rounded-xl bg-white border border-slate-200 p-4">
                  <div className="text-2xl font-black tracking-tight" style={{ color: primary }}>
                    {s.value}
                  </div>
                  <div className="text-[11px] uppercase tracking-wider text-slate-500 font-semibold mt-1">
                    {s.label}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="space-y-4">
          {why.map((w) => (
            <div
              key={w.title}
              className="rounded-2xl border border-slate-200 bg-white p-5 lg:p-6"
              data-testid={`ws-why-${w.title.toLowerCase().replace(/\s+/g, '-')}`}
            >
              <div className="flex items-start gap-4">
                <div
                  className="w-1 self-stretch rounded-full"
                  style={{ backgroundColor: primary }}
                />
                <div>
                  <h3 className="text-base font-bold text-slate-900 mb-1">{w.title}</h3>
                  <p className="text-sm text-slate-600 leading-relaxed">{w.body}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
